import { MDBBtn, MDBIcon } from "mdbreact"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Form, Input, Label, Media, Row, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import { SOLICITUD_ESTADOS } from "../../ayudas/constantes"
import { obtener_formulario_completo } from "../../ayudas/funciones"
import HistorialFormulario from "../../components/historial/historialFormulario"
import _valid from "../../validations"
import Select from 'react-select'
import ModalSolicitudConcurrente from "../../components/ModalPersonalizado/ModalSolicitudConcurrente"



export default class AsignarProyectoForm extends Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);
        const hayRegistro = _valid(props.datos);

        this.pathnameAnterior = props.pathnameAnterior

        this.state = {
            idRegistro: props.props,
            registro: hayRegistro ? props.datos.registro : {
                colaborador: 0,
                fecha_programada: undefined,
                fecha_fin: undefined,
                horas: 0
            }, 
            comentario: "",          
            modalEstaAbierto: false,
            colapsar: true,

            proyectos: [],
            colaboradores: [],
            departamentosAreas: [],
            tipoSolicitudes: [],
            colaboradorVista: undefined,
            departamentosAreaVista: undefined,
            modalNveces: false,
            Nveces: 1,
            borrar: true,
            mostrarSpinner: false,
            fecha_agenda: undefined,
            dia: undefined,
            dia2: undefined,
            proceso: false,
            tipo_de_agenda: undefined,
        };
        this.colapsar = this.colapsar.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.actualizarValoresNumericos = this.actualizarValoresNumericos.bind(this);
        this.actualizarDatosSeleccionados = this.actualizarDatosSeleccionados.bind(this);
        this.actualizaValoresEnPantalla = this.actualizaValoresEnPantalla.bind(this);
        this.ocultarModalN = this.ocultarModalN.bind(this);
        this.realizarRegistro = this.realizarRegistro.bind(this);
        this.abriModalN = this.abriModalN.bind(this);
        this.setValor = this.setValor.bind(this);
        this.actualizarFecha = this.actualizarFecha.bind(this);
        this.setDepartamento = this.setDepartamento.bind(this);
    }

    componentDidMount() {
        this.obtenerColaboradores();
        //this.obtenerProyectos();
        this.obtenerDepartamentosAreas();
        this.obtenerDatosSolicitudCompleta();
        if (_valid(this.state.registro.colaborador)) {
            let date = new Date();
            this.apiRest.get('/colaboradorPorID/' + this.state.registro.colaborador).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ colaboradorVista: resultado.data });
                }
            });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['colaborador']: this.state.registro.colaborador }
            }));
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['fecha_programada']: date.toISOString().split('T')[0] }
            }));
        }
    }

    obtenerColaboradores() {
        /* si tiene permiso de asignar se muestra todos los colaboradores del departamento */
        /* si no tiene permiso solamente se muestra al colaborador del usuario logeado */
        if(this.apiRest.tienePermiso('item_asignar')){
            this.apiRest.get('/colaboradorDepartamentoArea').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ colaboradores: resultado.data });
                }
            });
        } else {
            let usuario = this.apiRest.getLS('du');
            this.setState({ colaboradores: [{ id: usuario.colaborador.id, value: usuario.colaborador.id, 
                label: usuario.colaborador.id+" - "+usuario.first_name+" "+usuario.last_name }] });
        }        
    }
    
    obtenerDepartamentosAreas() {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
                this.siHayDepartamentoArea(resultado.data);
            }
        });
    }

    siHayDepartamentoArea = (departamentosAreas) => {
        let departamentoArea = [];
        if (_valid(this.state.registro.solicitar_a)) {
            this.apiRest.getRol() ?
                departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.id === this.state.registro.solicitar_a)
                :
                departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.value === this.state.registro.solicitar_a)
            this.setState({ departamentosAreaVista: departamentoArea });
            this.obtenerTipoSolicitud(departamentoArea.value);
            this.obtenerProyectos(departamentoArea.value);
        }
    }

    obtenerTipoSolicitud(departamentosAreaVista) {
        if (_valid(departamentosAreaVista)) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + departamentosAreaVista).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tipoSolicitudes: resultado.data });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    obtenerProyectos(departamentosAreaVista) {
        if (_valid(departamentosAreaVista)) {
            this.apiRest.get('/proyectoPorDepartamentoArea/' + departamentosAreaVista).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ proyectos: resultado.data });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }


    obtenerDatosSolicitudCompleta(id) {
        const idRegistro = this.state.idRegistro || id;
        if (!isNaN(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data, colaborador_que_acepta: resultado.data.colaborador_que_acepta_seleccionado });
                    if (_valid(resultado.imgSolicitudTrabajadaBase64)) {
                        this.setState({ imgSolicitudTrabajadaBase64: resultado.imgSolicitudTrabajadaBase64 })
                    }
                }
            });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }


    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    actualizarValoresNumericos = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: parseInt(value) }
        }));
    }

    actualizaValoresEnPantalla = (target) => {
        if (_valid(target)) {
            this.setState({
                departamentosAreaVista: target,
                registro: { ...this.state.registro, ['solicitar_a']: target.value, ['tipo_solicitud']: undefined }
            });
            this.obtenerTipoSolicitud(target.value);
            this.obtenerProyectos(target.value);
        } else {
            this.setState({
                departamentosAreaVista: undefined,
                registro: { ...this.state.registro, ['solicitar_a']: undefined,
                tipoSolicitudes: [],
                proyectos: [] }
            });
        }
    }

    /*actualizarDatosSeleccionados = (datos) => {
        if (_valid(datos)) {
            this.setState({ colaboradorVista: datos });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['colaborador']: datos.value }
            }));
        } else {
            this.setState({ colaboradorVista: undefined });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['colaborador']: undefined }
            }));
        }
    }*/

    actualizarDatosSeleccionados = (datos) => {
        if (_valid(datos)) {
            this.setState({ colaboradorVista: datos });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['colaborador']: datos.value }
            }));

            const departamentoSeleccionado = this.state.departamentosAreas.find(
                (dept) => dept.value === datos.id_departamento
            );
            if (departamentoSeleccionado && [41,68].includes(datos.id_departamento) ) {
                this.setState(estadoAnterior => ({
                    departamentosAreaVista: departamentoSeleccionado,
                    registro: {...estadoAnterior.registro, 
                        solicitar_a: departamentoSeleccionado.value, 
                        tipo_solicitud: undefined
                    }
                }));
                this.obtenerTipoSolicitud(departamentoSeleccionado.value);
                this.obtenerProyectos(departamentoSeleccionado.value);
            }
        } else {
            this.setState({ colaboradorVista: undefined });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['colaborador']: undefined }
            }));
        }
    }

    // Envío de correo al colaborador.
    // @param: id de la solicitud
    envioCorreo(id) {
        this.apiRest.get('/enviarCorreoSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error al enviar el correo, por favor intenta nuevamente.');
            }
        });
    }

    /*almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            if (typeof (historialGuardado) === "boolean") {
                if (historialGuardado) {
                    this.enviarValores();
                } else {
                    toastr.error("No se pudo guardar el historial, por favor intente de nuevo.");
                }
                this.setState({ modalEstaAbierto: false });
            } else {
                this.setState({ modalEstaAbierto: true });
            }
        }
    }*/

    almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            const { registro } = this.state;
            let datosFormulario = obtener_formulario_completo(registro);
            this.apiRest.putFiles('/solicitudProyectoActualizar/' + registro.id, datosFormulario).then(resultado => {
                if (resultado.exitoso) {
                    /*if (registro.estado === 3) {
                        this.enviarCorreoFinalizado(registro.id)
                    } else if (registro.estado === 5) {
                        this.enviarCorreoRechazo(registro.id)
                    } else {
                        this.enviarCorreoAsignado(registro.id)
                    }*/
                    /*if (typeof (historialGuardado) === "boolean") {*/
                    toastr.success("Solicitud asignada exitosamente!");
                    this.guardarEnHistorial();
                    this.asignarOdoo(registro.id);
                    this.whatsappAsignarSolicitud(registro.id);
                    this.props.props.actualizarFila(registro.id);
                    this.props.props.changeSideAbierto();                    
                    //this.props.props.history.replace(this.pathnameAnterior);
                    /*this.setState({ modalEstaAbierto: false });
                    } else {
                        this.setState({ modalEstaAbierto: true });
                    }*/
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    enviarCorreoAsignado = id => {
        this.apiRest.get('/enviarCorreoSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error al enviar el correo, por favor intenta nuevamente.');
            }
        });
    }

    enviarCorreoFinalizado = id => {
        this.apiRest.get('/correoSolicitudFinalizada/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado a colaborador solicitante.');
            }
        });
    }

    enviarCorreoRechazo = id => {
        this.apiRest.get('/correoRechazoSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado a colaborador solicitante.');
            }
        });
    }

    whatsappAsignarSolicitud(id) {
        this.apiRest.get('/whatsappAsignarSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Whatsapp enviado exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar whatsapp, por favor intenta nuevamente.');
            }
        });
    }

    enviarOdoo(id) {
        this.apiRest.get('/enviarOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Enviado a Odoo exitosamente!');
            } else {
                console.log('Ocurrió un error al crear el ticket en Odoo '+ id);
                /*toastr.error('Ocurrió un error al crear el ticket en Odoo', id, {
                    timeOut: 0, closeButton: true, extendedTimeOut: 0, tapToDismiss: false,
                });*/
            }
        });
    }

    asignarOdoo(id) {
        this.apiRest.get('/asignarOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Asignado a Odoo exitosamente!');
            } else {
                console.log('No se pudo asignar el ticket en Odoo '+ id);
                /*toastr.error('No se pudo asignar el ticket en Odoo', id, {
                    timeOut: 0, closeButton: true, extendedTimeOut: 0, tapToDismiss: false,
                });*/
            }
        });
    }

    guardarEnHistorial(){
        const { comentario } = this.state;
        //if (_valid(comentario)) {
            const { estado, id } = this.state.registro;
            let datos = { comentario };
            if (estado !== undefined) {
                datos["estado"] = parseInt(estado);
            }
            if (id) {
                datos["solicitud"] = id;
            }
            this.apiRest.post('/historial', datos).then(resultado => {
                if (resultado.exitoso) {
                    console.log('Se guardo el historial.');
                } else {
                    toastr.error("No se guardo comentario para el historial.");
                }
            });
        //}
    }

    /*enviarValores = async () => {
        const { registro } = this.state;
        let datosFormulario = obtener_formulario_completo(registro);

        await this.apiRest.putFiles('/solicitudProyectoActualizar/' + registro.id, datosFormulario).then(resultado => {
            if (resultado.exitoso) {
                this.envioCorreo(registro.id)
                toastr.success('Datos almacenados exitosamente!');

                this.props.props.history.replace(this.pathnameAnterior);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }*/


    datosRegistroValidos() {
        const { registro, comentario } = this.state;
        let valido = true;

        if (registro.estado == 5){
            if (!_valid(comentario)) {
                toastr.error("Escribe un comentario.");
                valido = false;
            }
        } else {
            if (!_valid(registro.colaborador)) {
                toastr.error("Colaborador es requerido.");
                valido = false;
            }
            if (!_valid(registro.tipo_solicitud)) {
                toastr.error("Tipo Solicitud es requerido.");
                valido = false;
            }
        }
        
        if (!_valid(registro.solicitar_a)) {
            toastr.error("Departamento es requerido.");
            valido = false;
        }
        
        /*if (!_valid(comentario)) {
            toastr.error("Escribe un comentario.");
            valido = false;
        }*/
        return valido;
    }

    //realizar n veces una nueva solicitud
    ocultarModalN = () => {
        this.setState({ modalNveces: false });
    }

    actualizarFecha = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
        const f = new Date();
        if (e.target.name == 'fecha_agenda') {
            if (_valid(e.target.value)) {
                if (this.fechaMayorIgualQue(e.target.value, this.formatoFecha(f))) {
                    this.setState({
                        proceso: true
                    })
                    let fecha = e.target.value
                    let date = new Date(fecha.replace(/-+/g, '/'));

                    let options = {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };
                    let d = date.toLocaleDateString('es-GT', options);
                    let n = date.getDate()
                    d = d.split(',')
                    this.setState({
                        dia: d[0],
                        dia2: n
                    })
                } else {
                    this.setState({
                        proceso: false
                    })
                    toastr.warning('La fecha de programación no puede ser menor a la fecha actual');
                }
            } else {
                this.setState({
                    proceso: false
                })
            }
        }
    }

    fechaMayorIgualQue(fecha1, fecha2) {
        let aFecha1 = fecha1.split('-');
        let aFecha2 = fecha2.split('-');
        let fFecha1 = new Date(aFecha1[0], aFecha1[1], aFecha1[2]);
        let fFecha2 = new Date(aFecha2[0], aFecha2[1], aFecha2[2]);
        if (fFecha1 >= fFecha2) {
            return true;
        } else {
            return false;
        }
    }

    formatoFecha(fecha) {
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();
        if (dia < 10) {
            dia = '0' + dia;
        }
        if (mes < 10) {
            mes = '0' + mes;
        }
        return anio + '-' + mes + '-' + dia;
    }

    realizarRegistro = () => {
        const {
            Nveces,
            fecha_agenda,
            tipo_de_agenda,
            registro
        } = this.state;

        if (_valid(registro)) {
            if (this.verificarNveces()) {
                let value = {
                    fecha_agenda: _valid(fecha_agenda) ? fecha_agenda : undefined,
                    tipo_de_agenda: _valid(tipo_de_agenda) ? tipo_de_agenda : undefined,
                    Nveces: _valid(Nveces) ? Nveces : undefined
                }
                this.setState({ mostrarSpinner: true });
                toastr.warning("Espere un momento por favor...");
                this.apiRest.put('/solicitudNveces/' + registro.id, value).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Se Agendaron exitosamente...' + Nveces + ' Solicitudes');
                        this.setState({
                            modalNveces: false,
                            borrar: false,
                            mostrarSpinner: false
                        });
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    verificarNveces = () => {
        const {
            Nveces,
            fecha_agenda,
            tipo_de_agenda,
            registro
        } = this.state;
        if(!_valid(Nveces)){
            toastr.error("Cantidad es requerido.");
        }

        if(!_valid(fecha_agenda)){
            toastr.error("Fecha de Inicio es requerida.");
        }

        if(!_valid(tipo_de_agenda)){
            toastr.error("Agendar es requerido.");
        }

        if (_valid(Nveces) && _valid(fecha_agenda) && _valid(tipo_de_agenda)) {
            return true;
        } else {
            return false
        }
    }

    abriModalN = () => {
        this.setState({ modalNveces: true });
    }

    setValor = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            [name]: value
        }));
    }

    setDepartamento = (target) => {
        if (_valid(target)) {
            this.obtenerTipoSolicitud(target.value);
            this.obtenerProyectos(target.value);
            this.setState({
                solicitar_a: target
            });
        } else {
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['solicitar_a']: undefined }
            }));
            this.setState({
                solicitar_a: null,
                tipoSolicitudes: [],
                proyectos: []
            });
        }
    }

    handleChange = ({ target: { name, value, checked } }) => {           
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, remoto: (checked) ? 1 : 0 }
        }));
    }

    render() {
        const {
            registro,
            modalEstaAbierto,
            colapsar,
            proyectos,
            colaboradores,
            departamentosAreas,
            colaboradorVista,
            modal,
            modalNveces,
            Nveces,
            borrar,
            fecha_agenda,
            tipo_de_agenda,
            dia,
            dia2,
            proceso,
            tipoSolicitudes
        } = this.state;

        return (
            <div>
                <React.Fragment>
                    <Card>
                        <CardBody>
                            <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="me-3">
                                            <i className="uil uil-receipt text-primary h2"></i>
                                        </div>
                                        <div className="flex-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">Asignar Proyecto / Colaborador</h5>
                                            <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                        </div>
                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                    </Media>
                                </div>
                            </Link>
                            <Collapse isOpen={colapsar}>
                                <div className="p-4 border-top">
                                    <Form>
                                        <div>
                                            <Row>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="solicitar_a" className="form-label">
                                                            Departamento / Area
                                                        </Label>
                                                        {/*<select
                                                            name="solicitar_a"
                                                            value={registro.solicitar_a}
                                                            onChange={this.actualizarValoresNumericos}
                                                            className="form-control"
                                                        >
                                                            <option value="">Seleccionar</option>
                                                            {departamentosAreas.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                                        </select> */}
                                                        <Select
                                                            name="solicitar_a"
                                                            options={departamentosAreas}
                                                            value={this.state.departamentosAreaVista}
                                                            onChange={this.actualizaValoresEnPantalla}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            noOptionsMessage={() => "No hay más opciones"}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="colaborador" className="form-label">
                                                            Asignar a (Colaborador)
                                                        </Label>
                                                        {
                                                            /*<select
                                                            name="colaborador"
                                                            value={registro.colaborador}
                                                            onChange={this.actualizarValoresNumericos}
                                                            className="form-control"
                                                        >
                                                            <option value="">Seleccionar</option>
                                                            {colaboradores.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                                        </select> */
                                                        }
                                                        <Select
                                                            name="colaborador"
                                                            options={colaboradores}
                                                            value={colaboradorVista}
                                                            onChange={this.actualizarDatosSeleccionados}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            noOptionsMessage={() => "No hay más opciones"}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="tipo_solicitud" className="form-label">
                                                            Tipo Solicitud
                                                        </Label>
                                                        <select
                                                            value={registro.tipo_solicitud}
                                                            onChange={this.actualizarValoresNumericos}
                                                            name="tipo_solicitud"
                                                            className="form-control"
                                                        >
                                                            <option value="0">Seleccionar</option>
                                                            {tipoSolicitudes.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                </Col>                                                                                                
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="prioridad" className="form-label">
                                                            Prioridad
                                                        </Label>
                                                        <select
                                                            value={registro.prioridad}
                                                            onChange={this.actualizarValoresNumericos}
                                                            name="prioridad"
                                                            className="form-control"
                                                        >
                                                            <option value="0">Baja</option>
                                                            <option value="1">Media</option>
                                                            <option value="2">Alta</option>
                                                            <option value="3">Emergencia</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <Label className="form-label">
                                                        Estado de Solicitud:
                                                    </Label>
                                                    <select
                                                        value={registro.estado}
                                                        onChange={this.actualizarValoresNumericos}
                                                        name="estado"
                                                        className="form-control"
                                                    >
                                                        <option key={0} value={0}>No Asignado</option>
                                                        <option key={1} value={1}>Asignado</option>
                                                        <option key={2} value={2}>Planificado</option>
                                                        <option key={7} value={7}>Autorizado</option>
                                                        <option key={3} value={3}>Concluido</option>
                                                        <option key={4} value={5}>Rechazado</option>
                                                    </select>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="proyecto" className="form-label">
                                                            Proyecto
                                                        </Label>
                                                        <select
                                                            value={registro.proyecto}
                                                            onChange={this.actualizarValoresNumericos}
                                                            name="proyecto"
                                                            className="form-control"
                                                        >
                                                            <option value="">Seleccionar</option>
                                                            {proyectos.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="fecha_programada" className="form-label">
                                                            Fecha Inicio
                                                        </Label>
                                                        <Input
                                                            name="fecha_programada"
                                                            value={registro.fecha_programada}
                                                            onChange={this.actualizarValores}
                                                            type="date"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="fecha_fin" className="form-label">
                                                            Fecha Fin
                                                        </Label>
                                                        <Input
                                                            name="fecha_fin"
                                                            value={registro.fecha_fin}
                                                            onChange={this.actualizarValores}
                                                            type="date"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={3} style={{display: 'none'}}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="horas" className="form-label">
                                                            Horas Programadas
                                                        </Label>
                                                        <Input
                                                            value={registro.horas || undefined}
                                                            onChange={this.actualizarValoresNumericos}
                                                            name="horas"
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Ingresar un numero"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={4}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="comentario" className="form-label">
                                                            Comentario (Para el historial)
                                                        </Label>
                                                        <Input
                                                            value={this.state.registro.comentario}
                                                            onChange={({ target: { value } }) => this.setState(ant => ({ ...ant, comentario: value }))}
                                                            name="comentario"
                                                            type="textarea"
                                                            className="form-control"
                                                            placeholder="Escribe un comentario"
                                                        />
                                                    </div>
                                                </Col>
                                                { 
                                                    (registro.solicitar_a == 35) ? (
                                                        <Col lg={12} className="text-center align-items-center justify-content-center">
                                                            <div className="mb-3 mb-4" style={{background: "#FFFDE6"}}>
                                                                <Label className="form-label">
                                                                    Remoto
                                                                </Label>
                                                                {" "}
                                                                <Input
                                                                    type="checkbox"
                                                                    value={registro.remoto}
                                                                    onChange={this.handleChange}
                                                                    defaultChecked={registro.remoto}
                                                                    className=""
                                                                />
                                                            </div>
                                                        </Col>
                                                    ) : ''
                                                }
                                                <Col lg={12}>
                                                    {
                                                        _valid(registro.id) && _valid(borrar) ?
                                                            <MDBBtn className="waves-effect" color="warning" onClick={() => { this.abriModalN() }}>
                                                                <MDBIcon icon="fas fa-arrow-right" />{' '}
                                                                Agendar solicitud
                                                            </MDBBtn>
                                                            : ''
                                                    }
                                                    {/*Allan Choxom 04-04-23: Se comento para que el componente funcione en un modal*/}
                                                    {/*<MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.props.history.replace(this.pathnameAnterior) }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>*/}                                                  
                                                    <MDBBtn className="waves-effect float-end" color="success" onClick={this.almacenarRegistro}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        LISTO
                                                    </MDBBtn>
                                                </Col>
                                                <Col lg={12}>
                                                    <p />
                                                    {
                                                        _valid(registro.clase_de_solicitud) && registro.clase_de_solicitud === 'user' ?
                                                            <ModalSolicitudConcurrente estadoModal={true} registro={this.state.registro}/>
                                                            :
                                                            <Label htmlFor="" className="form-label">
                                                                Solicitud Concurrente
                                                            </Label>
                                                    }
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                    {/* MODAL */}
                    < Modal isOpen={modalNveces} size="mm">
                        <ModalHeader>
                            Realizar N veces
                        </ModalHeader>
                        <ModalBody>
                            {this.state.mostrarSpinner &&
                                <Row>
                                    <Col style={{ display: "flex", justifyContent: "center" }}>
                                        <Spinner className="m-1" color="primary" />
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col lg={6}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="cantidad_baja" className="form-label">
                                            Cantidad:
                                        </Label>
                                        <Input
                                            name="Nveces"
                                            value={Nveces || undefined}
                                            onChange={this.setValor}
                                            min="0"
                                            type="number"
                                            className="form-control"
                                            placeholder="Ingrese N veces"
                                        />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <Label htmlFor="" className="form-label">
                                        Fecha de inicio
                                    </Label>
                                    <Input
                                        name="fecha_agenda"
                                        value={fecha_agenda || undefined}
                                        onChange={this.actualizarFecha}
                                        type="date"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="8">
                                    {
                                        _valid(proceso) ?
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="tipo_solicitud_concurrente" className="form-label">
                                                    Agendar
                                                </Label>
                                                <select
                                                    value={tipo_de_agenda || undefined}
                                                    onChange={this.actualizarFecha}
                                                    name="tipo_de_agenda"
                                                    className="form-control"
                                                >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value="4">Cada Semana el {dia}</option>
                                                    <option value="5">Cada Mes el dia {dia2}</option>
                                                    <option value='6'>Todos los dias apartir del {dia + ' ' + dia2}</option>
                                                </select>
                                            </div>
                                            : ''
                                    }
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter className="text-center">
                            <MDBBtn className="waves-effect" color="success" onClick={() => this.realizarRegistro()}>
                                <MDBIcon icon="fas fa-user-check" /> {' '}
                                Realizar
                            </MDBBtn>
                            <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalN()}>
                                <MDBIcon icon="fas fa-times" /> {' '}
                                Cancelar
                            </MDBBtn>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
                {
                    modalEstaAbierto && <HistorialFormulario
                        solicitud={registro.id}
                        estado={registro.estado}
                        estadoModal={modalEstaAbierto}
                        seGuardoEnHistorial={historialGuardado => this.almacenarRegistro(historialGuardado)}
                    />
                }
            </div >
        );
    }
}